<template>
  <authorization permissionKey="attendance_exam" can="read">
    <v-container fluid>
      <v-row>
        <v-col cols="auto" class="text-h3 gray--text">
          Exames
        </v-col>
        <v-col cols="auto">
          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                icon
                small
                v-on="on"
                :attrs="attrs"
                :to="`/pacientes/${attendance.patient.id}/exames`"
              >
                <v-icon>eva-file-outline</v-icon>
              </v-btn>
            </template>
            <span>Histórico</span>
          </v-tooltip>
        </v-col>

        <v-spacer />
        
        <!-- <authorization -->
        <!--   permissionKey="attendance_exam" -->
        <!--   can="save" -->
        <!--   v-slot:default="{ authorization }" -->
        <!-- > -->
        <!--   <v-col cols="auto" v-if="authorization"> -->
        <!--     <v-btn -->
        <!--       color="light-blue" -->
        <!--       :dark="!attendanceEsigned" -->
        <!--       @click="createExam" -->
        <!--       :disabled="attendanceEsigned" -->
        <!--     > -->
        <!--       Adicionar  -->
        <!--     </v-btn> -->
        <!--   </v-col> -->
        <!-- </authorization> -->
      </v-row>

      <ExamList
        :attendance="attendance"
        :attendanceEsigned="attendanceEsigned"
        :allowDelete="!attendanceEsigned"
      />
    </v-container>
  </authorization>
</template>

<script>
  import ExamList from "@/components/exam/list/index.vue";

  export default {
    name: "Exams",
    props: {
      attendance: Object,
      attendanceEsigned: Boolean,
    },
    components: {
      ExamList,
    },
    data() {
      return {
        exams: [],
      };
    },
    mounted() {
      this.refreshList();
    },
    apollo: {
      exams: {
        query: require("@/graphql/exam/exams.gql"),
        variables() {
          return {
            attendanceId: this.attendance.id,
          };
        },
        pollInterval: 20000,
      },
    },
    methods: {
      refreshList() {
        this.$apollo.queries.exams.refetch();
      },
      createExam() {
        if (this.attendanceEsigned) return;

        return this.apolloMutate({
          mutation: require("@/graphql/exam/save_exam.gql"),
          variables: {
            attendanceId: this.attendance.id,
          },
        }).then(({ data }) => {
          this.$router.push(`/prontuario/${this.attendance.id}/exames/${data.saveExam.id}`);
        });
      },
    },
  };
</script>

<style lang="scss" scoped></style>
